import React from 'react'

const Footer = () => {
  const contactPhone = "7048351004";
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <>
        {/* Footer */}
        <div
          style={{ backgroundColor: "#f2f9fc", color: "black" }}
          className="pt-3 pb-1 mt-5 border-top"
        >
          <footer>
            <div className="container">

              {/* YEAR updated */}
              <div className="row">
                <div className="col-12 d-flex justify-content-center">
                  <p className="fw-semibold mb-2 m-0">
                    {currentYear} Speech Innovation NC PLLC
                  </p>
                </div>
              </div>

              <div className="row gy-3 justify-content-center mt-3">

                {/* Hours (unchanged) */}
                <div className="col-12 col-md-6 col-lg-4 text-center">
                  <p className="fw-semibold mb-1">Hours of Operation</p>
                  <p className="mb-0">Monday - Friday: 8:00 AM – 6:00 PM</p>
                  <p className="mb-0">Saturday: 8:00 AM – 12:00 PM</p>
                  <p className="mb-0">Sunday: Closed</p>
                </div>

                {/* Phone updated to use contactPhone */}
                <div className="col-12 col-md-6 col-lg-4 text-center">
                  <p className="fw-semibold mb-1">Phone</p>
                  <p className="mb-0">
                    <a href={`tel:+1${contactPhone}`}>
                      ({contactPhone.slice(0, 3)}) {contactPhone.slice(3, 6)}-{contactPhone.slice(6)}
                    </a>
                  </p>
                </div>

                {/* Address (unchanged) */}
                <div className="col-12 col-md-6 col-lg-4 text-center">
                  <p className="fw-semibold mb-1">Address</p>
                  <p className="mb-0">
                    600 Towne Centre Blvd #201
                    <br />
                    Pineville, NC 28134
                  </p>
                </div>

              </div>
            </div>
          </footer>
        </div>
      </>
    </div>
  )
}

export default Footer
